import { Component, Input, OnInit } from '@angular/core'

@Component({
    selector: 'app-image-progress',
    templateUrl: './image-progress.component.html',
    styleUrls: ['./image-progress.component.css'],
})
export class ImageProgressComponent implements OnInit {

    @Input() percent: number = 98
    @Input() radius: number = 50
    @Input() outerStrokeWidth: number = 6
    @Input() innerStrokeWidth: number = 2

    @Input() unitsFontSize: string = '10'
    @Input() titleFontSize: string = '20'
    @Input() animationDuration: number = 300
    @Input() space: number = 4

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/commons/image-progress/image-progress.component.ts